import { useMemo } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Dashboard from './pages/Dashboard';

type RouterProps = {
  onSignOut: () => void;
};

export function Router({ onSignOut }: RouterProps) {
  const router = useMemo(
    () =>
      createBrowserRouter([
        {
          path: '/',
          element: <Dashboard onSignOut={onSignOut} />
        }
      ]),
    [onSignOut]
  );

  return <RouterProvider router={router} />;
}
